(function(){
  'use strict';

  var syncing = false;
  var pageSyncing = false;
  var timer = null;
  var BOGO_MAX_PACKS = 2;

  function cartText(item){
    return [item && item.product_title, item && item.variant_title].filter(Boolean).join(' ');
  }

  function isBogoCollectionItem(item){
    var ids = window.__soBogoCollectionProductIds;
    if (!Array.isArray(ids) || !item) return false;
    return ids.map(String).indexOf(String(item.product_id)) !== -1;
  }

  function hasBogoProperty(item){
    var properties = item && item.properties || {};
    return properties._so_bogo_offer === 'true' ||
      properties._so_bogo_offer === true ||
      properties._bogo_offer === 'true' ||
      properties._bogo_offer === true;
  }

  function isBogo(item){
    return isBogoCollectionItem(item) || hasBogoProperty(item) || /\bBOGO\b/i.test(cartText(item));
  }

  function isBundleBogo(item){
    if (typeof window.isTrimShakeOfferItem === 'function' && window.isTrimShakeOfferItem(item)) return false;
    if (isBogoCollectionItem(item)) return true;
    var text = cartText(item);
    return /\bBOGO\b/i.test(text) && /(?:2\s*OZ|2\s*OUNCE)/i.test(text);
  }

  function money(cents){
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function injectStyles(){
    if (document.getElementById('so-bogo-cart-styles')) return;
    var style = document.createElement('style');
    style.id = 'so-bogo-cart-styles';
    style.textContent = [
      '.so-bogo-cart-note{display:grid;justify-items:start;gap:5px;margin:8px 0 2px;font-size:11px;line-height:1.25;color:#2e381f}',
      '.so-bogo-cart-note__badge{display:inline-flex;align-items:center;min-height:20px;padding:0 7px;border-radius:999px;background:#eaf3e6;color:#2e381f;font-size:9px;font-weight:900;letter-spacing:.06em;text-transform:uppercase;white-space:nowrap}',
      '.so-bogo-cart-note__copy{display:block;font-size:11px;font-weight:800;color:#419146}',
      '.drawer-cart-item[data-so-bogo-maxed="true"] .quantity-btn:last-child{opacity:.28!important;cursor:not-allowed!important;pointer-events:none!important;background:#f3f4f6!important;color:#9ca3af!important}',
      '#CustomCartDrawer .drawer-shipping-section.so-bogo-unlocked .drawer-shipping-text{color:#2e381f!important;font-weight:800!important}',
      '#CustomCartDrawer .drawer-shipping-section.so-bogo-unlocked .drawer-progress-bar{background:#e7ebe2!important}',
      '#CustomCartDrawer .drawer-shipping-section.so-bogo-unlocked .drawer-progress-fill{background:#419146!important}',
      '#CustomCartDrawer .drawer-shipping-section.so-bogo-unlocked .drawer-progress-truck{display:none!important}',
      '#CustomCartDrawer .drawer-sticky-summary.so-has-bogo-savings{display:grid!important;grid-template-columns:1fr!important;align-items:stretch!important;gap:7px!important}',
      '#CustomCartDrawer .so-bogo-original,#CustomCartDrawer .so-bogo-savings{width:100%;display:flex;align-items:center;justify-content:space-between;gap:16px;font-size:12px;line-height:1.2;font-weight:720}',
      '#CustomCartDrawer .so-bogo-original{color:#6f7469}',
      '#CustomCartDrawer .so-bogo-original__value{text-decoration:line-through;text-decoration-thickness:1.5px;color:#777d71;font-size:13px;font-weight:760;white-space:nowrap}',
      '#CustomCartDrawer .so-bogo-savings{color:#419146;font-weight:800}',
      '#CustomCartDrawer .so-bogo-savings__value{font-size:13px;font-weight:900;white-space:nowrap}',
      '#CustomCartDrawer .drawer-sticky-summary.so-has-bogo-savings .drawer-subtotal{width:100%!important;display:flex!important;justify-content:space-between!important;align-items:center!important;font-size:17px!important;margin-top:2px!important;padding-top:8px!important;border-top:1px solid rgba(46,56,31,.12)!important}',
      '#CustomCartDrawer .drawer-sticky-summary.so-has-bogo-savings .drawer-price{font-size:19px!important;font-weight:850!important}',
      '#CustomCartDrawer .so-gummy-upsell-meta{display:block;margin-top:3px;color:#697061;font-size:10px;line-height:1.25;font-weight:700}',
      '[id^="SmokeOneCart-"] [data-so-bogo-page-bundle="true"] .so-cart-bogo-limit{margin-top:7px;color:#419146;font-size:11px;line-height:1.2;font-weight:800;white-space:nowrap}',
      '[id^="SmokeOneCart-"] [data-so-bogo-page-maxed="true"] button[aria-label="&plus;"],[id^="SmokeOneCart-"] [data-so-bogo-page-maxed="true"] button[aria-label="+"]{opacity:.28!important;cursor:not-allowed!important;pointer-events:none!important}',
      '@media screen and (max-width:768px){',
      '#CustomCartDrawer.so-bogo-cart-active .drawer-shipping-section.so-bogo-unlocked{margin:0 0 6px!important;padding:8px 0 11px!important}',
      '#CustomCartDrawer.so-bogo-cart-active .drawer-shipping-section.so-bogo-unlocked .drawer-shipping-text{margin-bottom:8px!important}',
      '#CustomCartDrawer.so-bogo-cart-active .drawer-cart-item[data-so-bogo-bundle="true"]{padding-top:12px!important;padding-bottom:14px!important}',
      '#CustomCartDrawer.so-bogo-cart-active .drawer-cart-item[data-so-bogo-bundle="true"] .so-bogo-cart-note{margin-top:6px!important;gap:4px!important}',
      '#CustomCartDrawer.so-bogo-cart-active .custom-cart-footer{gap:8px!important;padding:11px 18px calc(11px + env(safe-area-inset-bottom,0px))!important}',
      '#CustomCartDrawer.so-bogo-cart-active .drawer-sticky-summary.so-has-bogo-savings{gap:4px!important}',
      '#CustomCartDrawer.so-bogo-cart-active .drawer-sticky-summary.so-has-bogo-savings .drawer-subtotal{padding-top:6px!important;margin-top:1px!important}',
      '#CustomCartDrawer.so-bogo-cart-active .drawer-checkout-btn{min-height:54px!important}',
      '#CustomCartDrawer.so-bogo-cart-active .drawer-payment-methods{margin-top:8px!important}',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  async function getCart(){
    var res = await fetch('/cart.js', { headers:{'Accept':'application/json'}, cache:'no-store' });
    if (!res.ok) throw new Error('Could not read cart.');
    return res.json();
  }

  function addNote(row, item){
    if (!row || !item) return;
    var info = row.querySelector('.drawer-cart-item-info');
    if (!info) return;

    var qty = Math.max(1, Number(item.quantity || 1));
    var totalOz = qty * 2;
    var paidOz = qty;
    var freeOz = qty;
    var note = row.querySelector('.so-bogo-cart-note');
    var offerNote = row.querySelector('.so-bogo-line-note');

    if (offerNote) {
      if (note) note.remove();
      offerNote.className = 'so-bogo-cart-note';
      offerNote.setAttribute('data-so-offer-note', 'true');
      var offerBadge = offerNote.querySelector('strong');
      var offerCopy = offerNote.querySelector('span');
      if (offerBadge) offerBadge.className = 'so-bogo-cart-note__badge';
      if (offerCopy) offerCopy.className = 'so-bogo-cart-note__copy';
      note = offerNote;
    }

    if (note && note.getAttribute('data-so-offer-note') === 'true') return;

    if (!note) {
      note = document.createElement('div');
      note.className = 'so-bogo-cart-note';
      note.innerHTML = '<span class="so-bogo-cart-note__badge">BOGO DEAL</span><span class="so-bogo-cart-note__copy"></span>';
      info.appendChild(note);
    }

    var copy = note.querySelector('.so-bogo-cart-note__copy');
    if (copy) {
      copy.textContent = paidOz + ' OZ Paid + ' + freeOz + ' OZ Free • ' + totalOz + ' OZ Total';
    }
  }

  function syncBogoUnlockedMessage(drawer, bundleItems){
    var section = drawer.querySelector('.drawer-shipping-section');
    var text = drawer.querySelector('#shippingText');
    var fill = drawer.querySelector('#progressFill');
    var truck = drawer.querySelector('#progressTruck');
    if (!section || !text || !fill) return;

    var packs = (bundleItems || []).reduce(function(total, item){
      return total + Math.max(1, Number(item.quantity || 1));
    }, 0);

    if (packs > 0) {
      var freeOz = packs;
      section.classList.add('so-bogo-unlocked');
      text.textContent = freeOz + ' OZ FREE UNLOCKED';
      fill.style.width = '100%';
      if (truck) truck.style.left = '100%';
    } else {
      section.classList.remove('so-bogo-unlocked');
    }
  }

  function setSubtotalLabel(subtotal, label){
    if (!subtotal) return;
    var nodes = subtotal.childNodes;
    for (var i=0;i<nodes.length;i++) {
      if (nodes[i].nodeType === 3) {
        nodes[i].nodeValue = label + ': ';
        return;
      }
    }
    subtotal.insertBefore(document.createTextNode(label + ': '), subtotal.firstChild);
  }

  function syncBogoValueStack(drawer, bundleItems, cartTotal){
    var summary = drawer.querySelector('.drawer-sticky-summary');
    if (!summary) return;

    var savings = bundleItems.reduce(function(total, item){
      var qty = Math.max(1, Number(item.quantity || 1));
      var charged = Number(item.final_line_price ?? item.line_price ?? (Number(item.final_price ?? item.price ?? 0) * qty));
      var packPrice = Number(item.original_price ?? item.price ?? (charged / qty));
      return total + Math.max(0, packPrice * qty * 2 - charged);
    }, 0);

    var originalRow = summary.querySelector('.so-bogo-original');
    var savingsRow = summary.querySelector('.so-bogo-savings');
    var subtotal = summary.querySelector('.drawer-subtotal');

    if (!savings) {
      if (originalRow) originalRow.remove();
      if (savingsRow) savingsRow.remove();
      summary.classList.remove('so-has-bogo-savings');
      setSubtotalLabel(subtotal, 'Subtotal');
      return;
    }

    summary.classList.add('so-has-bogo-savings');
    setSubtotalLabel(subtotal, 'Total');

    if (!originalRow) {
      originalRow = document.createElement('div');
      originalRow.className = 'so-bogo-original';
      originalRow.setAttribute('aria-label', 'Regular value before BOGO savings');
      originalRow.innerHTML = '<span>Regular value</span><span class="so-bogo-original__value"></span>';
      if (subtotal) summary.insertBefore(originalRow, subtotal);
      else summary.appendChild(originalRow);
    }

    if (!savingsRow) {
      savingsRow = document.createElement('div');
      savingsRow.className = 'so-bogo-savings';
      savingsRow.setAttribute('aria-label', 'BOGO savings');
      savingsRow.innerHTML = '<span>BOGO savings</span><span class="so-bogo-savings__value"></span>';
      if (subtotal) summary.insertBefore(savingsRow, subtotal);
      else summary.appendChild(savingsRow);
    }

    var originalValue = originalRow.querySelector('.so-bogo-original__value');
    var savingsValue = savingsRow.querySelector('.so-bogo-savings__value');
    if (originalValue) originalValue.textContent = money(Number(cartTotal || 0) + savings);
    if (savingsValue) savingsValue.textContent = '−' + money(savings);
  }

  function syncBogoUpsell(drawer, hasBundleBogo){
    var section = drawer.querySelector('.drawer-upsells');
    if (!section) return;

    var hint = section.querySelector('.drawer-upsells__hint');

    if (!hasBundleBogo) {
      section.classList.remove('so-bogo-upsell');
      if (hint) hint.style.display = '';
      return;
    }

    section.classList.add('so-bogo-upsell');
    if (hint) hint.style.display = 'none';
  }

  async function correctBundleQty(item){
    if (!item || Number(item.quantity || 0) <= BOGO_MAX_PACKS || syncing) return false;
    syncing = true;
    try {
      var res = await fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({ id:item.key, quantity:BOGO_MAX_PACKS })
      });
      if (!res.ok) throw new Error('Could not correct BOGO quantity.');
      if (typeof window.loadCartItems === 'function') window.loadCartItems();
      if (typeof window.updateCartCount === 'function') window.updateCartCount();
      return true;
    } catch(err) {
      console.warn('BOGO bundle quantity correction failed:', err);
      return false;
    } finally {
      syncing = false;
    }
  }

  async function correctCartPageOverLimit(items){
    var overLimit = (items || []).filter(function(item){
      return isBundleBogo(item) && Number(item.quantity || 0) > BOGO_MAX_PACKS;
    });
    if (!overLimit.length || pageSyncing) return false;

    pageSyncing = true;
    try {
      for (var i=0;i<overLimit.length;i++) {
        var response = await fetch('/cart/change.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({ id:overLimit[i].key, quantity:BOGO_MAX_PACKS })
        });
        if (!response.ok) throw new Error('Could not enforce BOGO cart-page limit.');
      }
      window.location.reload();
      return true;
    } catch(err) {
      console.warn('BOGO cart-page quantity correction failed:', err);
      return false;
    } finally {
      pageSyncing = false;
    }
  }

  function decorateRows(drawer, items){
    var rows = drawer.querySelectorAll('.drawer-cart-item[data-product-id]');
    for (var i=0;i<rows.length;i++) {
      var row = rows[i];
      var pid = String(row.getAttribute('data-product-id') || '');
      var vid = String(row.getAttribute('data-variant-id') || '');
      var item = items.find(function(candidate){
        return String(candidate.product_id) === pid && String(candidate.variant_id) === vid;
      });
      if (!item) continue;

      if (isBogo(item)) addNote(row, item);
      if (isBundleBogo(item)) {
        var titleLink = row.querySelector('.drawer-cart-item-title a');
        var cleanTitle = String(item.product_title || '').replace(/\s+BOGO\b.*$/i, '').trim();
        if (String(item.product_id) === '10497757249830') {
          cleanTitle = 'LCG Shake';
          var variantLabel = row.querySelector('.drawer-cart-item-variant');
          if (variantLabel && String(item.variant_id) === '52998528139558') variantLabel.textContent = '2 OZ Pack (BOGO)';
        }
        if (titleLink && cleanTitle) titleLink.textContent = cleanTitle;
        var qty = Number(item.quantity || 0);
        var maxed = qty >= BOGO_MAX_PACKS;
        row.setAttribute('data-so-bogo-bundle','true');
        row.setAttribute('data-so-bogo-maxed', maxed ? 'true' : 'false');

        var plus = row.querySelector('.drawer-quantity-controls .quantity-btn:last-child');
        if (plus) {
          if (maxed) {
            plus.disabled = true;
            plus.setAttribute('aria-label','Maximum 2 BOGO packs reached');
            plus.removeAttribute('onclick');
          } else {
            plus.disabled = false;
            plus.setAttribute('aria-label','Add one more BOGO pack');
            if (!plus.getAttribute('onclick') && item.key) {
              plus.setAttribute('onclick', "handleQty(event, '" + String(item.key).replace(/'/g, "\\'") + "', " + (qty + 1) + ")");
            }
          }
        }

        if (qty > BOGO_MAX_PACKS) correctBundleQty(item);
      }
    }
  }

  function decorateCartPage(root, items){
    if (!root) return;

    var bundleItems = (items || []).filter(isBundleBogo);
    var rows = root.querySelectorAll('[data-line-item-key]');

    for (var i=0;i<rows.length;i++) {
      var row = rows[i];
      var key = String(row.getAttribute('data-line-item-key') || '');
      var item = bundleItems.find(function(candidate){
        return String(candidate.key) === key;
      });

      if (!item) {
        row.removeAttribute('data-so-bogo-page-bundle');
        row.removeAttribute('data-so-bogo-page-maxed');
        var staleNote = row.querySelector('.so-cart-bogo-limit');
        if (staleNote) staleNote.remove();
        continue;
      }

      var qty = Math.max(1, Number(item.quantity || 1));
      var maxed = qty >= BOGO_MAX_PACKS;
      row.setAttribute('data-so-bogo-page-bundle','true');
      row.setAttribute('data-so-bogo-page-maxed', maxed ? 'true' : 'false');

      var input = row.querySelector('input[name^="updates"][data-variant-id]');
      if (input) {
        input.setAttribute('min','1');
        input.setAttribute('max', String(BOGO_MAX_PACKS));
        input.setAttribute('aria-label','BOGO pack quantity — maximum 2');
        if (Number(input.value || 1) > BOGO_MAX_PACKS) input.value = String(BOGO_MAX_PACKS);
      }

      var plus = row.querySelector('button[aria-label="&plus;"],button[aria-label="+"]');
      if (plus) {
        plus.disabled = maxed;
        plus.setAttribute('aria-disabled', maxed ? 'true' : 'false');
        plus.setAttribute('title', maxed ? 'Maximum 2 BOGO packs' : 'Add one more BOGO pack');
      }

      var quantityWrap = input ? input.closest('.max-w-min') : null;
      if (quantityWrap && !quantityWrap.querySelector('.so-cart-bogo-limit')) {
        var note = document.createElement('div');
        note.className = 'so-cart-bogo-limit';
        note.textContent = 'Max 2 BOGO packs';
        quantityWrap.appendChild(note);
      }
    }
  }

  function syncPresentation(drawer, cart){
    if (!drawer || !cart) return;
    injectStyles();

    var items = cart.items || [];
    var bundleItems = items.filter(isBundleBogo);
    var hasBundleBogo = bundleItems.length > 0;

    drawer.classList.toggle('so-bogo-cart-active', hasBundleBogo);
    decorateRows(drawer, items);
    syncBogoUnlockedMessage(drawer, bundleItems);

    var staleOriginal = drawer.querySelectorAll('.drawer-sticky-summary .so-bogo-original');
    var staleSavings = drawer.querySelectorAll('.drawer-sticky-summary .so-bogo-savings');
    staleOriginal.forEach(function(node){ node.remove(); });
    staleSavings.forEach(function(node){ node.remove(); });

    syncBogoUpsell(drawer, hasBundleBogo);

    if (typeof window.setItemsBottomPadding === 'function') {
      requestAnimationFrame(window.setItemsBottomPadding);
    }
  }

  function patchCartRenderer(){
    if (window.__SO_BOGO_CART_RENDER_PATCHED__) return true;
    if (typeof window.updateCartDisplay !== 'function') return false;

    var originalUpdateCartDisplay = window.updateCartDisplay;
    window.updateCartDisplay = function(cart){
      originalUpdateCartDisplay(cart);
      var drawer = document.getElementById('CustomCartDrawer');
      if (drawer) syncPresentation(drawer, cart);
    };

    window.__SO_BOGO_CART_RENDER_PATCHED__ = true;
    return true;
  }

  async function syncAll(){
    injectStyles();
    patchCartRenderer();

    try {
      var cart = await getCart();
      var cartPage = document.querySelector('[id^="SmokeOneCart-"]');

      if (cartPage) {
        var corrected = await correctCartPageOverLimit(cart.items || []);
        if (corrected) return;
        decorateCartPage(cartPage, cart.items || []);
      }

      var drawer = document.getElementById('CustomCartDrawer');
      if (drawer) syncPresentation(drawer, cart);
    } catch(err) {
      console.warn('BOGO cart sync failed:', err);
    }
  }

  function schedule(){
    clearTimeout(timer);
    timer = setTimeout(syncAll, 60);
  }

  injectStyles();
  patchCartRenderer();

  document.addEventListener('DOMContentLoaded', function(){
    patchCartRenderer();

    var container = document.getElementById('cartItemsContainer');
    if (container && 'MutationObserver' in window) {
      new MutationObserver(function(){
        if (!window.__SO_BOGO_CART_RENDER_PATCHED__) patchCartRenderer();
      }).observe(container,{childList:true,subtree:true});
    }

    var cartPage = document.querySelector('[id^="SmokeOneCart-"]');
    if (cartPage && 'MutationObserver' in window) {
      new MutationObserver(schedule).observe(cartPage,{childList:true,subtree:true});
    }

    schedule();
  });

  document.addEventListener('cart:updated', schedule);
  document.addEventListener('cart:refresh', schedule);
  document.addEventListener('theme:product:add', schedule);

  document.addEventListener('click', function(e){
    var drawerPlus = e.target.closest('.drawer-cart-item[data-so-bogo-maxed="true"] .quantity-btn:last-child');
    var pagePlus = e.target.closest('[id^="SmokeOneCart-"] [data-so-bogo-page-maxed="true"] button[aria-label="&plus;"], [id^="SmokeOneCart-"] [data-so-bogo-page-maxed="true"] button[aria-label="+"]');
    if (!drawerPlus && !pagePlus) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
  }, true);

  function clampPageInput(e){
    var input = e.target.closest('[id^="SmokeOneCart-"] [data-so-bogo-page-bundle="true"] input[name^="updates"]');
    if (!input) return;
    var qty = parseInt(input.value || '1', 10);
    if (!Number.isFinite(qty) || qty < 1) qty = 1;
    if (qty > BOGO_MAX_PACKS) qty = BOGO_MAX_PACKS;
    input.value = String(qty);
  }

  document.addEventListener('input', clampPageInput, true);
  document.addEventListener('change', clampPageInput, true);
})();
